import { Injectable } from '@angular/core';
import { UserPropertiesManager } from 'src/app/analytics/user-properties-manager.interface';

@Injectable({
	providedIn: 'root'
})
export class CollaborationUserPropertiesService implements UserPropertiesManager {

    public init(): void {
        return;
    }
}